import { render, staticRenderFns } from "./UserStandardAvatar.vue?vue&type=template&id=9ff051ea&scoped=true&"
import script from "./UserStandardAvatar.vue?vue&type=script&lang=js&"
export * from "./UserStandardAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UserStandardAvatar.vue?vue&type=style&index=0&id=9ff051ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff051ea",
  null
  
)

export default component.exports